import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  showFuelSelection: true,
  isActionUpsell: false,
  isMixedMeterJourney: false
};

export const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setShowFuelSelection: (state, { payload }) => {
      state.showFuelSelection = payload;
    },
    setIsActionUpsell: (state, { payload }) => {
      state.isActionUpsell = payload;
    },
    setIsMixedMeterJourney: (state, { payload }) => {
      state.isMixedMeterJourney = payload;
    }
  }
});

export const {
  setInitialState,
  setShowFuelSelection,
  setIsActionUpsell,
  setIsMixedMeterJourney
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectShowFuelSelection = (state) =>
  selectSlice(state).showFuelSelection;
export const selectIsActionUpsell = (state) =>
  selectSlice(state).isActionUpsell;
export const selectIsMixedMeterJourney = (state) =>
  selectSlice(state).isMixedMeterJourney;

export default slice.reducer;
